import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import queryString from 'query-string';
import { ThunkDispatch } from 'redux-thunk';
import { addEntityToSaved } from 'actions/savedEntities';
import { WithRouterProps } from 'decorators/withRouter';
import PaymentsPage from './PaymentsPage';
import { addPermissions, WithPermissions } from 'decorators/addPermissions';
import fetchUpdateDictionary from 'helpers/dictionaries';
import { AnyObject } from 'types/Common';
import landingState from 'constants/landingState';
import { RootState, StoreProps } from 'store';
import ItemConfiguration from 'types/ItemConfiguration';
import Messages from 'constants/rpcTypes';
import { getPathUrl } from 'helpers/paymentsPayoutsRequest';
import path from 'helpers/path';
import getConfigurationByName from 'selectors/getConfigurationByName';
import tableNames from 'constants/tableNames';
import permissionReasons from 'constants/permissionReasons';
import savedEntities from 'constants/savedEntities';
import pageFeatures from 'constants/pageFeatures';
import ActionReducer from 'types/ActionReducer';
import { SortingType } from '../../types/sortings';

interface ConnectedProps {
  configuration: ItemConfiguration[];
  feature_configuration: ItemConfiguration[];
  sort: {
    field: string;
    order: SortingType;
  };
  tableData: {
    items: AnyObject[];
    isFetch: boolean;
  };
  isDemoUser: boolean;
}

type Props = ConnectedProps &
  StoreProps &
  WithPermissions &
  WithRouterProps<{ id?: string }>;

class PaymentsContainer extends Component<Props> {
  loadPaymentMethodGroup;
  constructor(props: Props) {
    super(props);
    this.loadPaymentMethodGroup = fetchUpdateDictionary.bind(
      this,
      'paymentMethodGroup'
    );
  }

  async componentDidUpdate(prevProps: Readonly<Props>) {
    //in some cases when new payments are being added, we may not have their paymentMethodType (DAS-6665)
    const { tableData } = this.props;
    if (
      !tableData.isFetch &&
      tableData.items.length !== prevProps.tableData.items.length
    ) {
      this.loadPaymentMethodGroup();
    }
  }

  render() {
    const {
      match: { params },
      configuration,
      feature_configuration,
      isDemoUser,
    } = this.props;

    if (!configuration) return null;

    return (
      <PaymentsPage
        id={params.id}
        isDemoUser={isDemoUser}
        configuration={configuration}
        feature_configuration={feature_configuration}
        sort={this.props.sort}
        goToPayment={this.goToPayment}
        openTabWithPayment={this.createTabWithPayment}
        isRefundEnabled={
          this.props.isEnabled(Messages.PaymentOperation_Refund) ||
          this.props.isDisabledByReason(
            Messages.PaymentOperation_Refund,
            permissionReasons.REASON_IS_NOT_AVAILABLE_FOR_SUPPORT
          )
        }
      />
    );
  }

  goToPayment = (data) => {
    if (this.props.isEnabled(Messages.Payments_Payment)) {
      const pathUrl = getPathUrl(tableNames.payments, data);
      if (pathUrl) {
        this.props.history.push(path(pathUrl));
      }
    }
  };
  createTabWithPayment = (data) => {
    const id = data.transactionId;
    const dispatch: ThunkDispatch<RootState, void, ActionReducer> =
      this.props.dispatch;

    const regex: RegExp = /\?.+/;

    const str: string = getPathUrl(tableNames.payments, data);

    const m: string = regex.exec(str)![0];

    const entityKey: 'payments' = savedEntities.payments;
    const { name, type, projectId } = queryString.parse(m);
    dispatch(
      addEntityToSaved({ entityKey, id, urlParams: { name, type, projectId } })
    );
  };
}

const mapStateToProps = (state): ConnectedProps => ({
  configuration: getConfigurationByName(state, tableNames.payments),
  feature_configuration: getConfigurationByName(
    state,
    pageFeatures[tableNames.payments] || null
  ),
  sort: state.data[tableNames.payments].sort,
  tableData: state.data.payments,
  isDemoUser: state.user.landingState === landingState.demoStage,
});

export default withRouter(
  connect(mapStateToProps)(addPermissions(PaymentsContainer))
);
